export const listTripsForUserProfile = (companyId: string, userProfileId: string, limit: number = 0, offset: number = 0) => {
  const route = `/companies/${companyId}/user_profiles/${userProfileId}/trips`;
  const query = `?limit=${limit}&offset=${offset}`;

  return `${route}${query}`;
};
